"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatAnalyticsSDK = void 0;
const analytics_gateway_types_1 = require("@checkatrade/analytics-gateway-types");
const context_1 = require("./lib/context");
const api_queue_1 = require("./lib/utils/api-queue");
const CatAnalyticsSDK = ({ apiKey, appVersion, baseUrl, environment, fetcher, }) => {
    const apiCall = (path) => async (data) => {
        try {
            const response = await fetcher(path, {
                method: 'POST',
                body: JSON.stringify(data),
                keepalive: true,
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey,
                },
            });
            if (!response.ok) {
                return { success: false };
            }
            return await response.json();
        }
        catch (e) {
            return {
                success: !e,
            };
        }
    };
    const flowPath = `${baseUrl}/events/flow`;
    const eventPath = `${baseUrl}/events`;
    const flowEventAPICall = apiCall(flowPath);
    const eventAPICall = apiCall(eventPath);
    const flowQueue = new api_queue_1.ApiQueue('FLOW', flowEventAPICall);
    const eventQueue = new api_queue_1.ApiQueue('EVENT', eventAPICall);
    const isFlowEvent = (e) => e.flow_id !== undefined;
    const trackEvent = (event, runtimeContext) => {
        const eventWithContext = {
            ...event,
            ...(0, context_1.getCoreEventContext)(appVersion, environment, runtimeContext),
        };
        if (isFlowEvent(eventWithContext)) {
            return flowQueue.add(eventWithContext);
        }
        return eventQueue.add({
            ...eventWithContext,
            ...(0, context_1.getTrackEventContext)(),
        });
    };
    const visibilityChangeHandler = () => {
        if (document.visibilityState === 'hidden') {
            void flowQueue.flushViaBeacon(flowPath);
            void eventQueue.flushViaBeacon(eventPath);
        }
    };
    const addBeaconListener = () => {
        document.addEventListener('visibilitychange', visibilityChangeHandler);
    };
    const removeBeaconListener = () => {
        document.removeEventListener('visibilitychange', visibilityChangeHandler);
    };
    return {
        addBeaconListener,
        removeBeaconListener,
        trackEvent,
        schemas: analytics_gateway_types_1.schemas,
    };
};
exports.CatAnalyticsSDK = CatAnalyticsSDK;
//# sourceMappingURL=sdk.js.map